export function parseFieldsArrayToObject<T extends string>(fields: T[]): Record<T, string>;
export function parseFieldsArrayToObject<T extends string, V>(fields: T[], value: V): Record<T, V>;
// eslint-disable-next-line func-style
export function parseFieldsArrayToObject<T extends string, V = string>(fields: T[], value?: V) {
    return fields.reduce((acc, field) => {
        acc[field] = value !== undefined ? value : '';

        return acc;
    }, <Record<T, V | string>>{});
}
